import { Injectable } from '@angular/core';
import { Observable, ReplaySubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class BulkEditQualificationsService {
  private _bulkEditDrawerVisible = new ReplaySubject<boolean>(1);
  private _bulkEditCanceled = new ReplaySubject<void>(1);
  private _bulkEditedQualifications = new Subject<void>();

  public bulkEditDrawerVisible$: Observable<boolean> =
    this._bulkEditDrawerVisible.asObservable();
  public bulkEditCanceled$: Observable<void> =
    this._bulkEditCanceled.asObservable();
  public bulkEditedQualifications$: Observable<void> =
    this._bulkEditedQualifications.asObservable();

  public setBulkEditDrawerVisible(newVisible: boolean): void {
    this._bulkEditDrawerVisible.next(newVisible);
  }

  public triggerBulkEditCanceled(): void {
    this.setBulkEditDrawerVisible(false);
    this._bulkEditCanceled.next();
  }

  public triggerBulkEditedQualifications(): void {
    this.setBulkEditDrawerVisible(false);
    this._bulkEditedQualifications.next();
  }
}
